import { render, staticRenderFns } from "./ClipItem.vue?vue&type=template&id=a361ce28"
import script from "./ClipItem.vue?vue&type=script&lang=js"
export * from "./ClipItem.vue?vue&type=script&lang=js"
import style0 from "./ClipItem.vue?vue&type=style&index=0&id=a361ce28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
